/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Superscript({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 15" {...props}><path fill="currentColor" fillRule="evenodd" d="M12.75 1.6a1.6 1.6 0 0 1 3.2 0v.326c0 .486-.184.954-.514 1.31l-.71.764h.624a.6.6 0 1 1 0 1.2h-2a.6.6 0 0 1-.44-1.008l1.646-1.773a.725.725 0 0 0 .194-.493V1.6a.4.4 0 0 0-.8 0v.23a.6.6 0 1 1-1.2 0V1.6ZM.3 3.5c0-1.16.94-2.1 2.1-2.1h7c1.16 0 2.1.94 2.1 2.1V5a.6.6 0 1 1-1.2 0V3.5a.9.9 0 0 0-.9-.9H6.5v10.8h1.4a.6.6 0 1 1 0 1.2h-4a.6.6 0 1 1 0-1.2h1.4V2.6H2.4a.9.9 0 0 0-.9.9V5A.6.6 0 1 1 .3 5V3.5Z" clipRule="evenodd" /></svg>;
}
;